export function UniversalMoneyMarketsIcon() {
  return (
    <svg
      width="335"
      height="196"
      viewBox="0 0 335 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_274_31)">
        <rect width="335" height="196" rx="14" fill="white" />
        <rect
          width="335"
          height="196"
          rx="14"
          fill="url(#paint0_radial_274_31)"
        />
        <path
          opacity="0.76"
          d="M-32 97L87.9586 -66H246.497L367 97"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M-7 97L97.9262 -45H236.598L342 97"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M16 99L107.096 -25H227.49L319 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M43 99L117.861 -2H216.799L292 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M68 99L127.829 17H206.899L267 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M92 99L137.398 36H197.396L243 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M114 99L146.47 54H189.383L222 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M-32 97L87.9586 262H246.497L367 97"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M-7 97L97.9262 240H236.598L342 97"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M16 99L107.096 221H227.49L319 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M43 99L117.861 198H216.799L292 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M68 99L127.829 179H206.899L267 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M92 99L137.398 160H197.396L243 99"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M114 99L146.47 142H189.383L222 99"
          stroke="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_274_31"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-347.803 291.958) rotate(-15.4288) scale(813.472 830.672)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <clipPath id="clip0_274_31">
          <rect width="335" height="196" rx="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
